var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-btn',_vm._b({staticClass:"button",class:{ 'expand': _vm.expand },attrs:{"no-caps":"","rounded":"","size":_vm.size},on:{"click":function($event){return _vm.$emit('click', $event)}}},'q-btn',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }